import { render, staticRenderFns } from "./ConsentView.vue?vue&type=template&id=2d63a528&scoped=true&style=background-color%3A%20transparent%3B%20position%3Arelative%3B"
import script from "./ConsentView.vue?vue&type=script&lang=js"
export * from "./ConsentView.vue?vue&type=script&lang=js"
import style0 from "./ConsentView.vue?vue&type=style&index=0&id=2d63a528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63a528",
  null
  
)

export default component.exports